/**
 * /trust — Trust Center hub page.
 *
 * Declares a TanStack Router route that renders `TrustCenterPage` from the
 * `features/trust-center/` surface. The hub pulls data in parallel from
 * nine trust-posture API endpoints (SOC2/ISO, DPA, sub-processors,
 * encryption posture, data residency, DPF, GDPR DSR, CCPA DSR, pentest,
 * plus the public Trust Center index).
 *
 * The root-owned `router.tsx` wire-up picks this module up after the
 * feature merges to prod-main. Agents never touch `router.tsx`.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { TrustCenterPage } from "@/features/trust-center/TrustCenterPage";

// ---------------------------------------------------------------------------
// Route — mounts at `/trust`. No search params yet; the hub is read-only.
// ---------------------------------------------------------------------------

export const trustRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/trust",
	component: TrustCenterPage,
});

export default trustRoute;

// Named export mirrors the convention used by `campaigns.os-targeting.tsx`
// so the root wire-up can import either the route or the page component.
export { TrustCenterPage } from "@/features/trust-center/TrustCenterPage";
